import SEO from '@libs/layout-app/seo'
import { image } from '@libs/layouts'
import { Navigate, Route, Routes } from 'react-router'
import CalloutNoExists from 'src/libs/useful/CalloutNoExists'
import { IProject } from '../../data/interfaces'
import { IFestProjectsProps, useFestProjects } from '../../data/store'
import FestHelp from '../help/FestHelp'
import Diary from './Diary'
import ProjectContainer from './ProjectContainer'
import ProjectEditForm from './ProjectEditForm'
import ProjectRate from './ProjectRate'
import RatingsReport from './RatingsReport'
import ProjectTeam from './team'



/* Protopia Ecosystem component */
export interface IProjectFormProps { 

}  

const ProjectScreenForm = ( props: IProjectFormProps ): JSX.Element => {  
    const item: IProject = useFestProjects((state: IFestProjectsProps) => state.currentProject) 
    return item?.id && item?.post_status === "publish"
        ?
        <> 
            <SEO
                title={item.title}
                description={item.post_content}
                image={item.thumbnail || image()}
            />
            <Routes>
                <Route path="" element={ <ProjectContainer /> } >
                    <Route index element={ <Navigate to="ratings" replace /> } /> 
                    <Route 
                        path='ratings'
                        element={ <ProjectRate /> }
                    />
                    <Route 
                        path="project-team"
                        element={ <ProjectTeam /> }
                    />
                    <Route 
                        path="management"
                        element={ <ProjectEditForm /> }
                    />
                    <Route 
                        path="diary"
                        element={ <Diary /> }
                    /> 
                    <Route 
                        path="ratings-report"
                        element={ <RatingsReport /> }
                    />
                    <Route path="*" element={ <Navigate to="ratings" replace /> } /> 
                </Route>
            </Routes>
            <FestHelp />
        </> 
        :
        <div className="p-5">
            <CalloutNoExists message={"No project exists"} /> 
        </div>
} 

export default ProjectScreenForm